// @ts-nocheck
import React, { useEffect, useState } from "react";
import { Table as BaseTable, Tag, Typography, Grid } from "antd";
import { truncate } from "lodash-es";
import { TABLE_RENDER_TYPES } from "/src/components/Table/utils";
import { useColumns } from "/src/components/Table/useColumns";
import useTransactions from "../../hooks/apis/useTransactions";
import useEventEffect from "src/hooks/useEvent";
import TransactionDetailsModal from "./TransactionDetailsModal";
import {
  ArrowUpOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  CloseOutlined,
  ExclamationCircleOutlined,
  MinusOutlined,
  PlusOutlined,
  PoundOutlined,
  PrinterOutlined,
  SyncOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import CurrencyAmount from "../CurrencyAmount";
import { Transaction } from "/src/types";
import { trackCompletedWithdrawals } from "src/utils/gtm";

const TRANSACTION_TYPE_COLORS = {
  DEPOSIT: "green",
  WITHDRAW: "crimson",
  REVERT: "orange",
};

const TRANSACTION_TYPES = {
  DEPOSIT: {
    label: "واریز",
    color: "green",
    icon: <PlusOutlined />,
  },
  WITHDRAW: {
    label: "برداشت",
    color: "red",
    icon: <MinusOutlined />,
  },
  REVERT: {
    label: "برگشت",
    color: "volcano",
    icon: <ExclamationCircleOutlined />,
  },
};
const TRANSACTION_STATUS = {
  PENDING: {
    label: "در‌انتظار",
    color: "volcano",
    icon: <ClockCircleOutlined />,
  },
  IN_PROGRESS: {
    label: "در حال انجام",
    color: "blue",
    icon: <SyncOutlined spin />,
  },
  SUCCESS: {
    label: "انجام شده",
    color: "green",
    icon: <CheckCircleOutlined />,
  },
  CANCELLED: {
    label: "کنسل شده",
    color: "red",
    icon: <CloseCircleOutlined />,
  },
};

const getColumns = (detailed: boolean = false) => [
  {
    key: "type",
    title: "نوع",
    render: (value) => (
      <Tag
        bordered={false}
        icon={TRANSACTION_TYPES[value].icon}
        color={TRANSACTION_TYPES[value].color}
      >
        {TRANSACTION_TYPES[value].label}
      </Tag>
    ),
  },
  {
    key: "status",
    title: "وضعیت",
    render: (value) => (
      <Tag
        bordered={false}
        color={TRANSACTION_STATUS[value].color}
        icon={TRANSACTION_STATUS[value].icon}
      >
        {TRANSACTION_STATUS[value].label}
      </Tag>
    ),
  },

  {
    title: "تاریخ",
    key: "succeededAt",
    render: TABLE_RENDER_TYPES.DATE,
  },
  {
    key: "amount",
    width: 200,
    title: "مبلغ",
    render: (value: number, record: { currency: string }) => (
      <CurrencyAmount color={value > 0 ? "green" : "crimson"} amount={Math.abs(value)} currency={record.currency} />
    ),
  },
  {
    key: "channel",
    title: "کانال",
    render: (channel: { url: string; title: string } | null) =>
      channel ? (
        <Typography.Link href={channel.url} rel="noopener noreferrer" target="_blank">
          {channel.title}
        </Typography.Link>
      ) : (
        "-"
      ),
  },
  // {
  //   key: "fee",
  //   title: "کارمزد",
  //   render: (value?: { total: number }, record: Transaction) => {
  //     if (!value || !value.total) {
  //       return "-";
  //     }
  //     return <CurrencyAmount amount={Math.abs(value?.total ?? 0)} currency={record.currency} />;
  //   },
  // },
  // {
  //   key: "irtAmount",
  //   title: "مبلغ کل",
  //   render: (_: any, record: Transaction) => {
  //     const total = Math.abs(record.amount + (record.fee?.total ? record.fee.total : 0));
  //     return <CurrencyAmount amount={total} currency={record.currency} />

  //   },
  // },
  {
    title: "توضیحات",
    key: "description",
    ellipsis: true,
    width: 200,
    render: (value: string) => (
      <Typography.Text
        ellipsis={{ tooltip: value || undefined }}
        style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", maxWidth: 200, display: "block" }}
      >
        {value ? (detailed ? value : truncate(value, { length: 50 })).split("|").join("\n") : "-"}
      </Typography.Text>
    ),
  },
];

interface TransactionsTableProps {
  detailed?: boolean;
}

const TransactionsTable: React.FC<TransactionsTableProps> = ({ detailed }) => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });
  const [selectedWithdraw, setSelectedWithdraw] = useState<any | null>(null);
  const screens = Grid.useBreakpoint();

  const { data, isLoading, mutate } = useTransactions(pagination);
  const normalizedColumns = useColumns(getColumns(detailed));

  useEffect(() => {
    if (data?.data) trackCompletedWithdrawals(data.data);
  }, [data?.data]);

  const handleTableChange = (newPagination: any) => {
    setPagination({
      current: newPagination.current || pagination.current,
      pageSize: newPagination.pageSize || pagination.pageSize,
    });
  };

  useEventEffect(() => {
    mutate();
  }, 'refresh-transactions')

  return (
    <>
      <BaseTable
        columns={normalizedColumns}
        dataSource={data?.data || []}
        loading={isLoading}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: data?.total || 0,
          pageSizeOptions: ["10", "20", "50"],
          showSizeChanger: true,
        }}
        onChange={handleTableChange}
        onRow={(record) => ({
          onClick: () => {
            setSelectedWithdraw(record);
          },
        })}
        rowKey="id"
        size="small"
        className="mt-4"
        scroll={screens.md ? { x: 1024 } : undefined}
      />
      <TransactionDetailsModal
        withdraw={selectedWithdraw}
        onClose={() => setSelectedWithdraw(null)}
      />
    </>
  );
};

export default TransactionsTable;
export { getColumns };
